// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';

function SuperUserRoutes({ children }) {
  const { user } = useSelector(state => state.user);
  if (!user?.is_superuser) {
    return <Navigate to='/unauthorized' replace />;
  }

  return children;
}

export default SuperUserRoutes;
